define([ 
         "jquery",
         "wcs.context",
         "pubsub"
        ],
		
function($, ctx) {
	
	var DEBUG = false;
    var PLUGIN_IDENTIFIER = 'storeFavCookie';
    var storeFavCookie = function(element, options) {

		this.element = element;
		this.options = options || {};

		this.storeID = ctx.getStoreId();

		this.bopisConfig = WCS_CONFIG.get('BOPIS');
		this.latLongCheck = "^(\\+|\\-)?[0-9]+(\.[0-9]+)?$";

		this.uPOS = ctx.getCookie('uPOS') || false;
		this.isRegisteredUser = ctx.getCookie('USER_TYPE'+ctx.getStoreId()) === 'R';

		this.useCurrentLocation = this.options.useCurrentLocation || true;
		this.favoriteStoreCookie = this._getFavCookie();
		this.favoriteStoreDetailsCookie = this._getFavStoreDetailsCookie();

    };
      
    storeFavCookie.prototype = {
        
        defaults: {
        	userInfoEndpoint: '/wcs/resources/store/'+ctx.getStoreId()+'/person/@self' 
        },
        
        init: function() {

        	var self = this;

        	this.config = $.extend(true, {}, this.defaults, this.options);

        	// favorite store & store name cookie is already set, do nothing
        	if ( this.favoriteStoreCookie && this.favoriteStoreDetailsCookie ) {
        		return;
        	}

        	this._getCookieValues().done( function () {
        		self._retrieveStoreList();
        	});       	

            return this;
        },

        _getCookieValues : function () {

        	if (DEBUG) console.log('BOPISSTORE - _getCookieValues');

        	var $deferred = $.Deferred();

        	this.userEnteredZipCookie = this._getUserEnteredZipCookie();
        	this.geoLocationZipCookie = this._getZipLocationCookie();
        	this.geoLocationLatLongCookie = this._getGeoLocationCookie();
        	
        	// if this is a POS location, then do not get user information
        	if ( this.uPOS ) {
        		$deferred.resolve();
        		return $deferred.promise();
        	} 

        	// only get user information for address if this is a registered user
        	if ( !this.isRegisteredUser ) {
        		$deferred.resolve();
        		return $deferred.promise();
        	}
        		
    		this._getLoggedInUserInfo().done( function ( primaryAddress ) {
        		self.primaryAddress = primaryAddress;
        		$deferred.resolve();
        	});	
        	
        	return $deferred.promise();
        },
             
        _getUserEnteredZipCookie : function () {

        	if (DEBUG) console.log('BOPISSTORE - _getUserEnteredZipCookie');

        	return ctx.getCookie('USER_ENTERED_ZIP') || false;
        },

        _getLoggedInUserInfo : function () {

        	if (DEBUG) console.log('BOPISSTORE - _getLoggedInUserInfo');

        	var self = this,
        		$deferred = $.Deferred();

        	$.ajax({
        		url: this.config.userInfoEndpoint
        	}).done(function(data){
        		$deferred.resolve(self._getLoggedInUserAddress(data));
        	}).fail(function(){
        		$deferred.resolve(false);
        	});

        	return $deferred.promise();

        },

        _getLoggedInUserAddress : function (data) {

        	if (DEBUG) console.log('BOPISSTORE - _getLoggedInUserAddress');

        	if ( typeof data.contact === 'undefined' ) {
        		return false;
        	}

        	var primaryAddress = data.contact.filter(function(contactInfo){
        		return (contactInfo.addressType === 'Shipping' || contactInfo.addressType === 'ShippingAndBilling') && contactInfo.primary == 'true';
        	})[0];

        	if ( typeof primaryAddress === 'undefined' || typeof primaryAddress.zipCode === 'undefined' ) {
        		return false;
        	}

        	return primaryAddress.zipCode.split("-")[0];
        },

        _getGeoLocationCookie : function () {
        	
        	if (DEBUG) console.log('BOPISSTORE - _getGeoLocationCookie');
        	
        	return ctx.getCookie("Edgescape-Lat-Long") || false;
        },
        
        _getZipLocationCookie : function () {
        	
        	if (DEBUG) console.log('BOPISSTORE - _getZipLocationCookie');
        	
        	return ctx.getCookie("Edgescape-Zip") || false;
        },
        
        _getFavCookie : function () {
        	
        	if (DEBUG) console.log('BOPISSTORE - _getFavCookie');
			
			var favCookieName = this.bopisConfig.bopisFavStore + ctx.getStoreId(),
				result = ctx.getCookie(favCookieName);
			
			if (result !== null && result !== undefined ) {
				return result;
			}
			
			return false;
		},

		_getFavStoreDetailsCookie : function () {

			if (DEBUG) console.log('BOPISSTORE - _getFavStoreDetailsCookie');

			var favStoreDetailsCookie = this.bopisConfig.bopisFavStore + 'DETAILS' + ctx.getStoreId() ,
				result = ctx.getCookie(favStoreDetailsCookie);

			if (result !== null && result !== undefined ) {
				return result;
			}
			
			return false;
		},

		_buildAjaxParams : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildAjaxParams');

			return {
				type: this.bopisConfig.w2giServerApiEnabled && this._buildAddressLine() ? 'GET' : 'POST',
				url: this.bopisConfig.w2giServerApiEnabled ? this.bopisConfig.w2giServerApiURL : this._buildAjaxURL(),
				dataType: 'xml',
				data: this._buildAjaxDataParams()
			};

		},

		_buildAjaxDataParams : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildAjaxDataParams');
			
			if ( this.bopisConfig.w2giServerApiEnabled ) {			
				return	{
					radius: this.bopisConfig.w2giMaxRadius,
					addressLine: this._buildAddressLine(),
					latLong: this._buildAddressLine() === '' ? this._buildLatLongParam() : ''
				};	
			
			} else {
				return this._getQueryXMLURL(this.useCurrentLocation).split('?')[1];
			}
		},

		_buildAddressLine : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildAddressLine');

			// if uPOS cookie exists and is true, only use geoLocationZipCookie
			if ( this.uPOS == 'true' && this.geoLocationZipCookie ) {
        		return this.geoLocationZipCookie.slice(0,5);
        	}

			// user entered zip code cookie exists, get stores based on this
        	if ( this.userEnteredZipCookie ) {
        		return this.userEnteredZipCookie.slice(0,5);
        	}

        	// logged in user has a saved address, use this for store cookie
        	if ( this.loggedInUserAddress ) {
        		return this.loggedInUserAddress.slice(0,5);
        	}

        	// use to geo location zipcode cookie if none of above are able to produce favorite store
        	if ( this.geoLocationZipCookie ) {
        		return this.geoLocationZipCookie.slice(0,5);
        	}

        	return '';

		},

		_buildLatLongParam : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildLatLongParam');

			// as last resort, use geolocation lat long information to produce favorite store
        	if ( this.geoLocationLatLongCookie && this._isLatLongValid() ) {
				return this.geoLocationLatLongCookie;
        	}
		},

		_isLatLongValid : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildAddressLine');

			this.latLongArr = this.geoLocationLatLongCookie.split(",");
			return this.latLongArr.length > 1 && this.latLongArr[0].match(this.latLongCheck) && this.latLongArr[1].match(this.latLongCheck);
		},

		_buildAjaxURL : function () {

			if (DEBUG) console.log('BOPISSTORE - _buildAjaxURL');

			return this._getQueryXMLURL(this.useCurrentLocation).split('?')[0];
		},

		_retrieveStoreList : function() {
			
			if (DEBUG) console.log('BOPISSTORE - _retrieveStoreList');

			var self = this,
				$deferred = $.Deferred();
				
			$.ajax(this._buildAjaxParams()).done(function (data) {	  		
		  		data = self._processDataForCookie(data);
				$deferred.resolve(data);
			}).fail(function(e) {
				console.error(e);
			});
			
			return $deferred.promise();
		},
		
	  _processDataForCookie : function(data) {
		 
		  	if (DEBUG) console.log('BOPISSTORE - _processDataForCookie');

		  	var xml              =  $(data), 
			    response         =  xml.find("response").attr("code"), 
			    poi              =  xml.find("poi"), listval = "", postalCode = "",
			    eSIList          =  [],
			    postalCodeList   =  [],
			    jsonReturn;
			
			eSIList = this._buildESI(poi);
			postalCodeList = this._buildpostalCode(poi);
			
			listval = eSIList[0];
			postalCode = postalCodeList[0];
			if ( listval !== null && listval !== undefined) {
				var postfix = this.bopisConfig.bopisFavStore; 
				if (this._getGeoLocationCookie() !== null && this._getGeoLocationCookie() !== undefined) {
					var favStoreIdcookieName = postfix + ctx.getStoreId();
					var favStoreDetailsCookieName = postfix + 'DETAILS' + ctx.getStoreId();
					ctx.setCookie(favStoreIdcookieName, listval.id);
					ctx.setCookie(favStoreDetailsCookieName, JSON.stringify({"name": listval.name}) );
					if(postalCode){
						ctx.setCookie("STORE_ZIP_VALUE", postalCode);
						ctx.setCookie("USER_ENTERED_ZIP", postalCode);
					}
				}
			}
			$.pubsub('publish', 'vfdp.favoriteStoreCookie.set');
			$.pubsub('publish', 'vfdp.favoriteStoreDetailsCookie.set');
		},
		
	  _buildpostalCode : function(poi) {

	  	if (DEBUG) console.log('BOPISSTORE - _buildpostalCode');

		  var postalCodeList = [];
		  $(poi).each(
					function(index, value) {
						postalCodeList.push($(value).find("postalcode").text());
					});
		  return postalCodeList;
	  },
	  
	  _buildESI : function(poi) {
	  	
	  	if (DEBUG) console.log('BOPISSTORE - _buildESI');

		  var eSIList = [];
			$(poi).each(
					function(index, value) {
						var storeInfo = {
							'id': $(value).find("enterprise_store_identifier").text(),
							'name' : $(value).find("name").text()
						};
						eSIList.push(storeInfo);
					});
			return eSIList;
		},
		
	  _getQueryXMLURL : function(useCurLocation) {

	  	if (DEBUG) console.log('BOPISSTORE - _getQueryXMLURL');
		    
			var queryURL = this.bopisConfig.w2giURL, 
				appKey = this.bopisConfig.w2giKey, 
				limit = this.bopisConfig.w2giStoreLimit, 
				whereClauseBrand = this.bopisConfig.w2giWhereClauseBrand, 
				storeRadius = this.bopisConfig.w2giMaxRadius, 
				countryCode = this.bopisConfig.pdpInStoreW2GICountryCode, 
				lat_long = this._getGeoLocationCookie() ? this._getGeoLocationCookie().split(","): [ "", "" ],
				zipcode = this._getZipLocationCookie() ? this._getZipLocationCookie().split("-")[0] : "",
				geoloc = '<geolocs><geoloc>';

			if (useCurLocation && zipcode !== "") {
				geoloc += '<addressline>' + zipcode + '</addressline>';
			} else if (useCurLocation && lat_long[0].match(this.latLongCheck) && lat_long[1].match(this.latLongCheck)) {
				geoloc += '<longitude>' + lat_long[1] + '</longitude>';
				geoloc += '<latitude>' + lat_long[0] + '</latitude>';
			} else {
				geoloc += '<addressline></addressline>';
			}

			geoloc += '</geoloc></geolocs>';

			var xml = '';

			if (whereClauseBrand !== '') {
				xml = [
						'<request>',
						'<appkey>' + appKey + '</appkey>',
						'<formdata id="locatorsearch">',
						'<dataview>store_default</dataview>',
						'<order>_distance</order>',
						'<softmatch>1</softmatch>',
						'<limit>' + limit + '</limit>',
						'<atleast>1</atleast>',
						'<searchradius>' + storeRadius + '</searchradius>',
						geoloc,
						'<stateonly>1</stateonly>',
						'<nobf>1</nobf>',
						'<where>',
						'<' + whereClauseBrand + '><eq>1</eq></'+ whereClauseBrand + '>',
						'<country><eq>' + countryCode + '</eq></country>',
						'</where>', '</formdata></request>' ];
			} else {
				xml = [
						'<request>',
						'<appkey>' + appKey + '</appkey>',
						'<formdata id="locatorsearch">',
						'<dataview>store_default</dataview>',
						'<order>_distance</order>',
						'<softmatch>1</softmatch>',
						'<limit>' + limit + '</limit>',
						'<atleast>1</atleast>',
						'<searchradius>' + storeRadius + '</searchradius>',
						geoloc,
						'<stateonly>1</stateonly>',
						'<nobf>1</nobf>',
						'<where>',
						'<tnvn><eq></eq></tnvn>',
						'<country><eq>' + countryCode + '</eq></country>',
						'<or>',
						'<off><eq>TRUE</eq></off>',
						'<out><eq></eq></out>',
						'<aut><eq></eq></aut>',
						'</or></where></formdata></request>' ];
			}
			queryURL = queryURL + encodeURIComponent(xml.join(""));
			return queryURL;
		}
        
    };

    storeFavCookie.defaults = storeFavCookie.prototype.defaults;
	$.fn.storeFavCookie = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new storeFavCookie(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};
});